<div class="modal-header">
  <h4 class="modal-title h5" translate>Trigger action</h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form (ngSubmit)="onSave()" [formGroup]="triggerQueryForm">
  <div class="modal-body">
    <div class="form-row">

      <!-- ACTION TYPE -->
      <div class="col-12 col-lg-4">
        <div class="form-group">
          <label for="actionType" translate>Action type</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <ng-select (change)="onActionTypeChange($event)" [items]="actionTypes"
            [ngClass]="{ 'is-invalid': f.actionType.errors }"
            bindLabel="name" bindValue="id" formControlName="actionType" id="actionType">
          </ng-select>
          <input [hidden]="true" [ngClass]="{ 'is-invalid': f.actionType.errors }" class="form-control"
            id="selectedActionType" type="text">
            @if (f.actionType.errors) {
              <div class="invalid-feedback">
                @if (f.actionType.errors.required) {
                  <span translate>Action type required</span>
                }
              </div>
            }
          </div>
        </div>

        <!-- NAME -->
        <div class="col-12 col-lg-5">
          <div class="form-group">
            <label for="name" translate>Name</label>
            <scitis-required-field-indicator></scitis-required-field-indicator>
            <input [ngClass]="{ 'is-invalid': f.name.errors }" class="form-control" formControlName="name"
              id="name" name="name"
              type="text">
              @if (f.name.errors) {
                <div class="invalid-feedback">
                  @if (f.name.errors.required) {
                    <span translate>Trigger action name required</span>
                  }
                </div>
              }
            </div>
          </div>

          <!-- DELAY -->
          <div class="col-12 col-lg-3">


            <div class="form-group">
              <label for="delayInSeconds" translate>Delay</label>
              <div class="input-group">
                <input [ngClass]="{ 'is-invalid': f.delayInSeconds.errors }"
                  class="form-control"
                  formControlName="delayInSeconds" id="delayInSeconds" max="2147483647"
                  min="0" name="delayInSeconds" step="1"
                  type="number">
                  <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon2">sec.</span>
                  </div>
                </div>
                @if (f.delayInSeconds.errors) {
                  <div class="invalid-feedback">
                    @if (f.delayInSeconds.errors.required) {
                      <span translate>Value required</span>
                    }
                    @if (f.delayInSeconds.errors.min) {
                      <span translate>Value too low! The minimum is 0</span>
                    }
                    @if (f.delayInSeconds.errors.max) {
                      <span translate>Value too high! The maximum is 2147483647.</span>
                    }
                    @if (f.delayInSeconds.errors.pattern) {
                      <span translate>The value is not a valid integer!</span>
                    }
                    @if (f.delayInSeconds.errors.step) {
                      <span translate>The value is not a valid integer!</span>
                    }
                  </div>
                }
              </div>
            </div>

          </div>

          @if (selectedActionType === TRIGGER_ACTION_TYPE.EMAIL) {
            <scitis-admin-email-action-type
              (formIsValid)="onTriggerQueryEmailFormIsValid($event)"
              (updatedTriggerQueryAction)="onUpdatedTriggerQueryEmail($event)"
              [addTriggerAction]="addTriggerAction"
              [userRole]="userRole"
              [triggerQueryAction]="triggerQueryAction">
            </scitis-admin-email-action-type>
          }

          @if (selectedActionType === TRIGGER_ACTION_TYPE.NOTIFICATION) {
            <scitis-admin-notification-action-type
              (formIsValid)="onTriggerQueryNotificationFormIsValid($event)"
              (updatedTriggerQueryAction)="onUpdatedTriggerNotification($event)"
              [userRole]="userRole"
              [triggerQueryAction]="triggerQueryAction">
            </scitis-admin-notification-action-type>
          }

          @if (selectedActionType === TRIGGER_ACTION_TYPE.PUBSUB) {
            <scitis-admin-pub-sub-action-type
              (formIsValid)="onTriggerQueryPubSubFormIsValid($event)"
              (updatedTriggerQueryAction)="onUpdatedTriggerPubSub($event)"
              [triggerQueryAction]="triggerQueryAction">
            </scitis-admin-pub-sub-action-type>
          }

        </div>

        <div class="modal-footer">
          <div class="modal-footer-inner">
            <div class="row align-items-center flex-fill">
              <div class="col">
                <scitis-required-field-indicator-explanation></scitis-required-field-indicator-explanation>
              </div>
              <div class="col-auto">
                <button (click)="onCancel()" class="btn btn-outline-primary mr-2" type="button">
                  <span translate>Cancel</span>
                </button>
                <button [disabled]="isSubmitButtonDisabled" class="btn btn-primary" type="submit">
                  <span translate>Save</span>
                </button>
              </div>
            </div>
          </div>
        </div>

      </form>
